<template>
  <div>
    <!-- Optionally show NavBar based on a condition -->
    <nav-bar v-if="false"></nav-bar>

    <menu-bar></menu-bar>

    <router-view></router-view>

    <footer-bar></footer-bar>
    <footer-mini></footer-mini>

    <!-- Spinner (currently hidden) -->
    <!--
    <div class="main-spinner">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    -->
  </div>
</template>

<script setup>
import { watch } from 'vue'
import { useRoute } from 'vue-router'

import FooterBar from './components/FooterBar.vue'
import FooterMini from './components/FooterMini.vue'
import MenuBar from './components/MenuBar.vue'
import NavBar from './components/NavBar.vue'

const route = useRoute()

// Update metadata based on route meta
watch(
  () => route.meta,
  (meta) => {
    if (meta.title) {
      document.title = meta.title
    }

    if (meta.description) {
      let descTag = document.querySelector('meta[name="description"]')
      if (!descTag) {
        descTag = document.createElement('meta')
        descTag.name = 'description'
        document.head.appendChild(descTag)
      }
      descTag.content = meta.description
    }

    if (meta.keywords) {
      let keywordsTag = document.querySelector('meta[name="keywords"]')
      if (!keywordsTag) {
        keywordsTag = document.createElement('meta')
        keywordsTag.name = 'keywords'
        document.head.appendChild(keywordsTag)
      }
      keywordsTag.content = meta.keywords
    }
  },
  { immediate: true }
)
</script>

<style scoped lang="scss">
.text-info {
  display: none;
}
</style>
